module.exports = __webpack_public_path__ + "img/cooperativa_medalla_milagrosa.6e1f169c.png";